import { render, staticRenderFns } from "./PendingCases.vue?vue&type=template&id=99da2f4a&"
import script from "./PendingCases.vue?vue&type=script&lang=js&"
export * from "./PendingCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports